import { useState } from 'react';

/**
 * Create a hook that returns the an array and a method to add or remove items
 * in that array.
 *
 * @param {Array} initialState The initial state.
 *
 * @return {Array} An array containing the state and a method to update the state.
 */
export default (initialState) => {
  const [state, setState] = useState(initialState);

  const toggle = (item) => {
    const position = state.indexOf(item);

    setState(
      position !== -1
        ? [...state.slice(0, position), ...state.slice(position + 1)]
        : [...state, item],
    );
  };

  const setBulk = (values) => {
    setState([...new Set([...state, ...values])]);
  };

  const removeBulk = (values) => {
    setState(state.filter((item) => !values.includes(item)));
  };

  const reset = (newState) => setState(newState);

  return {
    state,
    toggle,
    setBulk,
    removeBulk,
    reset,
  };
};
